import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { LogoModule } from "src/app/components/logo/logo.module";
import { IonicModule } from "@ionic/angular";
import { HomePageRoutingModule } from "./home-routing.module";
import { HomePage } from "./home.page";
import { RouterModule } from "@angular/router";
import { ChallengeLayoutModule } from "src/app/components/challenge-layout/challenge-layout.module";
import { IsNewsLikedByMePipe } from "src/app/pipes/is-news-liked-by-me/is-news-liked-by-me.pipe";
import { NewsFeedModule } from "src/app/organisms/news-feed/news-feed.module";
import { BackgroundImageDirectiveModule } from "src/app/directives/background-image/background-image.module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HomePageRoutingModule,
    LogoModule,
    RouterModule,
    ChallengeLayoutModule,
    NewsFeedModule,
    BackgroundImageDirectiveModule,
    TranslateModule,
  ],
  declarations: [HomePage],
  providers: [IsNewsLikedByMePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomePageModule {}
